import React from 'react';
import useSWR from 'swr';

import handleError from 'react-scale/lib/handle-error';

import DocsContainer from 'react-scale/containers/docs';
import { getDocsIndexData } from '../api/docs';

export async function fetchDocsIndexData() {
  const res = await fetch('/api/docs');
  if (!res.ok) {
    throw res.text();
  }
  return res.json();
}

export async function getStaticProps() {
  let props = {};
  try {
    props = await getDocsIndexData();
  } catch (error) {
    handleError(error);
  }
  return { props, revalidate: 1 };
}

const Docs = props => {
  const { data } = useSWR('docs-index', fetchDocsIndexData, {
    fallbackData: props,
    refreshInterval: 5000
  });

  return (
    <DocsContainer
      topLevelNavigation={data.topLevelNavigation}
      subLevelNavigation={data.subLevelNavigation}
    />
  );
};

export default Docs;
